import {AlertsController} from "./alerts.controller";
import {AlertDetailsController} from "./alert_details.controller";

function alertsConfig ($stateProvider) {

    $stateProvider
            .state('alerts', {
                url: '/alerts/{tab}',
                params: {watcherNameFilter: '', tab: '', title: 'Alerts'},
                parent: 'app-layout',
                templateUrl: 'states/alerts/alerts.html',
                controller: 'AlertsController as Alerts'

            })
            .state('alerts.details', {
                url: '/alerts/{alertID}/details',
                parent: 'app-layout',
                templateUrl: 'states/alerts/alert_details.html',
                controller: 'AlertDetailsController as AlertDetails',
                params: {
                    title: 'Alert Details'
                }
            })
}

export default angular.module('alerts', [])
        .config(alertsConfig)
        .controller('AlertsController', AlertsController)
        .controller('AlertDetailsController', AlertDetailsController)


// WEBPACK FOOTER //
// ./modules/xray/states/alerts/alerts.module.js